<template>
    <div class="page">
        <img
            @click="changePlay()"
            ref="on"
            class="on"
            src="~@/assets/jinniuyuanjing/on.png"
            alt=""
        />
        <audio ref="audio" src="~@/assets/jinniuyuanjing/bg.mp3" loop></audio>
        <audio ref="audio1" src="~@/assets/jinniuyuanjing/bg1.mp3"></audio>
        <audio ref="audio2" src="~@/assets/jinniuyuanjing/bg2.mp3"></audio>

        <div class="page1" :class="[ifCare ? 'active' : '']">
            <img class="bg" data-src="bg.jpg" alt="" />
            <div class="deng-box" ref="clone">
                <img class="deng" alt="" data-src="deng.png" />
                <img ref="txt1" class="txt" :src="titleImg" alt="" />
                <div class="user-box">
                    <img class="headImg" :src="headimgurl" alt="" />
                    <div class="username">
                        <span>{{ nickname }}</span>
                    </div>
                    <!-- <img class="sign" :src="sign" alt="" /> -->
                </div>
            </div>
            <!-- <div class="deng-box deng-box-clone" ref="clone">
                <img
                    class="deng"
                    src="~@/assets/jinniuyuanjing/deng.png"
                    alt=""
                />
                <img ref="txt2" class="txt" :src="titleImg" alt="" />
                <div class="user-box">
                    <div class="headImg"></div>
                    <div class="username">
                        <span>大家疯狂啦 </span>
                    </div>
                </div>
            </div> -->
            <img
                class="niu1"
                alt=""
                :class="[runningAnimate ? 'active' : '']"
                data-src="niu1.png"
            />
            <img
                class="niu2"
                alt=""
                :class="[runningAnimate ? 'active' : '']"
                data-src="niu2.png"
            />
            <img
                ref="clound1"
                class="cloud1"
                :class="[runningAnimate ? 'active' : '']"
                data-src="cloud1.png"
                alt=""
            />
            <img
                class="cloud2"
                :class="[runningAnimate ? 'active' : '']"
                data-src="cloud2.png"
                alt=""
            />
            <div class="btns">
                <img
                    @click="update"
                    alt=""
                    data-src="btn1.png"
                    :class="[runningAnimate ? 'active' : '']"
                />
                <img
                    @click="xuyuan"
                    alt=""
                    data-src="btn2.png"
                    :class="[runningAnimate ? 'active' : '']"
                />
            </div>
            <div class="btns2">
                <img
                    @click="update"
                    alt=""
                    data-src="btn3.png"
                    :class="[runningAnimate ? 'active' : '']"
                />
                <img
                    @click="xuyuan"
                    alt=""
                    data-src="btn4.png"
                    :class="[runningAnimate ? 'active' : '']"
                />
            </div>
            <div class="intro-box">
                <div class="intro" ref="intro">
                    {{ content }}
                </div>
                <div class="qrcode-box">
                    <img
                        :class="[runningAnimate ? 'active' : '']"
                        class="dage"
                        data-src="qrcode3.jpg"
                        alt=""
                    />
                    <img
                        :class="[!runningAnimate ? 'active' : '']"
                        class="qrcode"
                        data-src="qrcode2.png"
                        alt=""
                    />
                    <img
                        class="qrcode-bg"
                        :class="[runningAnimate ? 'active' : '']"
                        alt=""
                        data-src="qrcode-box.png"
                    />
                    <img
                        class="qrcode-bg"
                        :class="[!runningAnimate ? 'active' : '']"
                        alt=""
                        data-src="qrcode-box2.png"
                    />
                </div>
            </div>
            <div
                class="zz"
                :class="[imgSrc ? 'active' : '']"
                @click="close($event)"
            >
                <img :src="imgSrc" alt="" />
                <img class="notice" data-src="notice.png" alt="" />
            </div>
        </div>
        <div
            class="page2"
            :class="[!ifCare ? 'active' : '']"
            data-bg-src="bg2.jpg"
        >
            <div class="num-box">
                已有 <span class="num">{{ inNum }}</span> 人在道达号许下新年愿望
            </div>
            <img
                class="qrcode"
                src="~@/assets/jinniuyuanjing/qrcode.png"
                alt=""
            />
        </div>
        <div class="loading" ref="loading">
            <div class="progress-box">
                <img
                    class="yuanbao"
                    src="../../assets/jinniuyuanjing/yuanbao.png"
                    alt=""
                    ref="yuanbao"
                />
                <div class="progress" ref="progress">
                    <span ref="loadedProgress"></span>
                </div>
                <div class="footer">
                    <span>0%</span>
                    <span>100%</span>
                </div>
            </div>
        </div>
        <!-- <div class="sign-box" :class="[showSign ? 'active' : '']">
            <sign-canvas
                class="sign-canvas"
                ref="SignCanvas"
                :options="options"
            />
            <div class="sign-btns">
                <button>清除</button>
                <button @click="saveSignImg">确定</button>
            </div>
        </div> -->
    </div>
</template>

<script>
    import html2canvas from "html2canvas";
    import inobounce from "inobounce";
    import contentList from "./content";
    import jinniuyuanjingService from "../../service/jinniuyuanjing.service";
    // import SignCanvas from "sign-canvas";
    export default {
        name: "jinniuyuanjing",
        // components: {
        //     SignCanvas,
        // },
        data() {
            return {
                // options: {
                //     isDpr: false, //是否使用dpr兼容高倍屏 [Boolean] 可选
                //     lastWriteSpeed: 1, //书写速度 [Number] 可选
                //     lastWriteWidth: 2, //下笔的宽度 [Number] 可选
                //     lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
                //     lineJoin: "bevel", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
                //     canvasWidth: (window.innerWidth * 2) / 3, //canvas宽高 [Number] 可选
                //     canvasHeight: window.innerHeight, //高度  [Number] 可选
                //     isShowBorder: true, //是否显示边框 [可选]
                //     bgColor: "#fcc", //背景色 [String] 可选
                //     borderWidth: 1, // 网格线宽度  [Number] 可选
                //     borderColor: "#ff787f", //网格颜色  [String] 可选
                //     writeWidth: 5, //基础轨迹宽度  [Number] 可选
                //     maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
                //     minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
                //     writeColor: "#101010", // 轨迹颜色  [String] 可选
                //     isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
                //     imgType: "png",
                // },
                // showSign: false,
                // sign: null,
                count: 0,
                animating: false,
                imgSrc: "",
                contentList,
                content: "",
                titleImg: "",
                loaded: 0,
                process: 0,
                runningAnimate: true,
                yuanbaoEl: null,
                loadedProgressEl: null,
                progressWidth: 0,
                playAudio: false,
                ifCare: false,
                nickname: "",
                headimgurl: "",
                total: 0,
                contentIndex: Math.floor(this.getRandom(contentList.length)),
                titleIndex: Math.floor(this.getRandom(24, 1)),
                inNum: undefined,
            };
        },
        created() {
            inobounce.enable();
            this.getMyInfo();
        },
        async mounted() {
            this.createAnimate();
            this.progressWidth = this.$refs.progress.offsetWidth;
            this.yuanbaoEl = this.$refs.yuanbao;
            this.loadedProgressEl = this.$refs.loadedProgress;
            await this.loading();
            this.update();
            this.play();
            this.watchBtnClick();
        },

        methods: {
            watchBtnClick() {
                let bg = this.$refs.audio;
                this.$refs.audio1.addEventListener("play", () => {
                    bg.volume = 0.3;
                });
                this.$refs.audio1.addEventListener("ended", () => {
                    bg.volume = 1;
                });
                this.$refs.audio2.addEventListener("play", () => {
                    bg.volume = 0.3;
                });
                this.$refs.audio2.addEventListener("ended", () => {
                    bg.volume = 1;
                });
            },

            saveSignImg() {
                this.sign = this.$refs.SignCanvas.saveAsImg();
                this.showSign = false;
            },
            getMyInfo() {
                jinniuyuanjingService.getMyInfo().then((res) => {
                    this.ifCare = res.data.ifCare;
                    this.nickname = res.data.userInfo.nickname;
                    this.headimgurl = res.data.userInfo.headimgurl;
                    this.loaded++;
                    this.inNum = res.data.inNum;
                    this.progress();
                });
            },
            submitJinniu() {
                jinniuyuanjingService.submitJinniu({}).then(() => {});
            },
            play() {
                let audioEl = this.$refs.audio;
                let onEl = this.$refs.on;

                audioEl.addEventListener("play", () => {
                    onEl.classList.add("active");
                    // document.body.removeEventListener(
                    //     "touchstart",
                    //     this.handlerAudio
                    // );
                });
                audioEl.addEventListener("pause", () => {
                    onEl.classList.remove("active");
                });

                // document.body.addEventListener("touchstart", this.handlerAudio);
                try {
                    window.WeixinJSBridge.invoke(
                        "getNetworkType",
                        {},
                        function() {
                            if (audioEl.paused) {
                                audioEl.play();
                            }
                        },
                        false
                    );
                } catch {
                    console.log("error");
                }
                if (audioEl.paused) {
                    audioEl.play();
                }
            },
            handlerAudio() {
                let audioEl = document.querySelector("audio");
                if (audioEl.paused) {
                    audioEl.play();
                }
            },
            async loading() {
                let imgs = Array.from(document.querySelectorAll("[data-src]"));
                let bgImgs = Array.from(
                    document.querySelectorAll("[data-bg-src]")
                );

                let preLoadingImg = [];
                for (let i = 1; i <= 24; i++) {
                    preLoadingImg.push(`${i}.png`);
                }

                this.total =
                    imgs.length + bgImgs.length + preLoadingImg.length + 1;

                // this.loadSource(null, "AUDIO", "bg.mp3");

                preLoadingImg.forEach((item) => {
                    this.loadSource(null, "PRELOADING", item);
                });
                imgs.forEach((item) => {
                    this.loadSource(item, "IMG");
                });
                bgImgs.forEach((item) => {
                    this.loadSource(item, "BG");
                });
            },
            loadSource(imgEL, type, src) {
                this.setImg(imgEL, type, src)().then(() => {
                    this.loaded++;
                    this.progress();
                });
            },
            progress() {
                let total = this.total;
                let num = (this.loaded * this.progressWidth) / total;
                this.yuanbaoEl.style.transform = `translateX(${num}px)`;
                this.loadedProgressEl.style.width = `${num}px`;
                // alert(this.loaded, total);
                if (this.loaded == total) {
                    this.$refs.loading.classList.add("hide");
                }
            },
            getBase64Image(img) {
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                ctx.mozImageSmoothingEnabled = false;
                ctx.webkitImageSmoothingEnabled = false;
                ctx.msImageSmoothingEnabled = false;
                ctx.imageSmoothingEnabled = false;

                ctx.drawImage(img, 0, 0, img.width, img.height);
                var dataURL = canvas.toDataURL("image/png"); // 可选其他值 image/jpeg
                return dataURL;
            },
            setImg(imgEL, type, url) {
                let count = 0;
                return () => {
                    return new Promise((resolve) => {
                        let img = new Image();
                        // img.setAttribute("crossOrigin", "anonymous");

                        let src = "";
                        if (type == "IMG") {
                            src = require(`../../assets/jinniuyuanjing/${imgEL.dataset.src}`);
                            img.src = src;
                        } else if (type == "BG") {
                            src = require(`../../assets/jinniuyuanjing/${imgEL.dataset.bgSrc}`);
                            img.src = src;
                        } else if (type == "PRELOADING") {
                            src = require(`../../assets/jinniuyuanjing/${url}`);
                            img.src = src;
                        } else if (type == "AUDIO") {
                            // let auidoEl = this.$refs.audio;
                            // src = require(`../../assets/jinniuyuanjing/${url}`);
                            // auidoEl.src = src;
                            // auidoEl.addEventListener("canplay", () => {
                            //     resolve();
                            // });
                        }

                        img.addEventListener("load", () => {
                            if (imgEL) {
                                if (type == "IMG") {
                                    // imgEL.setAttribute("crossOrigin", "*");
                                    if (!src.includes("data:image")) {
                                        // let t = new Date().getTime();
                                        imgEL.src = this.getBase64Image(img);
                                        // imgEL.src = src + "?t=" + t;
                                    } else {
                                        imgEL.src = src;
                                    }
                                } else if (type == "BG") {
                                    imgEL.style.backgroundImage = `url(${src})`;
                                }
                            }
                            resolve();
                        });
                        img.addEventListener("error", () => {
                            this.setImg.count++;
                            this.setImg(imgEL, type);
                            if (count >= 3) {
                                resolve();
                                return;
                            }
                        });
                    });
                };
            },
            changePlay() {
                this.playAudio = !this.playAudio;
                let audioEl = this.$refs.audio;
                if (audioEl.paused) {
                    audioEl.play();
                } else {
                    audioEl.pause();
                }
            },
            close(e) {
                let target = e.target;
                if (target.classList.contains("zz")) {
                    this.imgSrc = "";
                    this.runningAnimate = true;
                }
                this.$refs.clone.classList.remove("active");
            },
            xuyuan() {
                if (this.animating) {
                    return;
                }
                this.$refs.audio2.play();
                this.submitJinniu();
                this.animating = true;
                this.$refs.clone.classList.remove("active");
                this.createXiaodeng();
            },
            update() {
                try {
                    this.$refs.audio1.play();
                } catch (error) {
                    console.log(error);
                }
                let tex1El = this.$refs.txt1;
                let introEl = this.$refs.intro;

                let len = contentList.length;
                let contentIndex = Math.floor(this.getRandom(len, 0));
                let titleIndex = Math.floor(this.getRandom(24, 1));
                while (contentIndex == this.contentIndex) {
                    contentIndex = Math.floor(this.getRandom(len, 0));
                }
                this.contentIndex = contentIndex;
                while (titleIndex == this.titleIndex) {
                    titleIndex = Math.floor(this.getRandom(24, 1));
                }
                this.titleIndex = titleIndex;

                this.titleImg = require(`../../assets/jinniuyuanjing/${titleIndex}.png`);

                tex1El.classList.add("active");
                introEl.classList.add("active");

                tex1El.addEventListener("animationend", () => {
                    tex1El.classList.remove("active");
                });
                introEl.addEventListener("animationend", () => {
                    introEl.classList.remove("active");
                });
                setTimeout(() => {
                    this.content = contentList[contentIndex];
                }, 500);
            },
            createXiaodeng() {
                this.count = 0;
                setTimeout(() => {
                    this.$refs.clone.classList.add("active");
                }, 25);
                let count = Math.ceil(this.getRandom(15, 8));
                for (let i = 0; i < count; i++) {
                    this.getXiaodengInfo(i, count);
                }
            },
            getXiaodengInfo(index, num) {
                let opacity = this.getRandom(1, 0.6).toFixed(1);
                let w = this.getRandom(70, 40).toFixed(0);
                let x = 0;
                if (window.innerWidth <= 540) {
                    x = this.getRandom(
                        window.innerWidth - w / 3,
                        -w / 3
                    ).toFixed(0);
                } else {
                    x = this.getRandom(
                        (window.innerWidth - 540) / 2 + 540 - Number(w),
                        (window.innerWidth - 540) / 2 + Number(w)
                    );
                }
                let y = this.getRandom(window.innerHeight, window.innerHeight);
                let animationIndex = Math.floor(this.getRandom(30, 1));
                let direction = Math.floor(this.getRandom(3500, 2000));
                let img = new Image();
                img.classList.add("xiaodeng");
                img.src = require("../../assets/jinniuyuanjing/xiao-deng.png");
                img.style.cssText = `position:absolute;width:${w}px;left:${x}px;top:${y}px;z-index:200;opacity:${opacity}; animation: x_d_${animationIndex} ${direction}ms ease-out 20ms forwards`;
                document.querySelector(".page").appendChild(img);
                img.addEventListener("animationend", () => {
                    this.count++;
                    if (this.count == num) {
                        let xiaodnegEls = document.querySelectorAll(
                            ".xiaodeng"
                        );
                        for (
                            let i = 0, len = xiaodnegEls.length;
                            i < len;
                            i++
                        ) {
                            let xiaodengEl = xiaodnegEls[i];
                            xiaodengEl.parentNode.removeChild(xiaodengEl);
                        }
                        this.runningAnimate = false;
                        setTimeout(() => {
                            this.createImg();
                            this.animating = false;
                        }, 100);
                    }
                });
            },
            createImg() {
                html2canvas(document.querySelector(".page"), {
                    scale: window.devicePixelRatio,
                    x:
                        window.innerWidth > 540
                            ? (window.innerWidth - 540) / 2
                            : 0,
                    y: 0,
                    width: window.innerWidth > 540 ? 540 : window.innerWidth,
                    height: window.innerHeight,
                    useCORS: true,
                    ignoreElements: function(el) {
                        if (
                            el.classList.contains("deng-box-clone") ||
                            el.classList.contains("btns") ||
                            el.classList.contains("btns2") ||
                            el.classList.contains("on")
                        ) {
                            return true;
                        }
                        return false;
                    },
                }).then((canvas) => {
                    let url = canvas.toDataURL();
                    this.imgSrc = url;
                });
            },

            getRandom(max, min) {
                return Math.random() * (max - min) + min;
            },
            createAnimate() {
                let styleEl = document.createElement("style");
                let css = "";
                let arr = [];
                let h =
                    document.documentElement.clientHeight ||
                    document.body.clientHeight;

                for (let i = 0; i < 30; i++) {
                    let step1 = Math.floor(this.getRandom(40, 15));
                    while (arr.includes(step1)) {
                        step1 = Math.floor(this.getRandom(40, 15));
                    }
                    let opacity = this.getRandom(0.8, 0.2).toFixed(1);

                    css += `@-webkit-keyframes x_d_${i + 1}{
                        0%{
                            opacity:0;
                        }
                        ${step1}%{
                            opacity:${opacity};
                            -webkit-transform:translateY(0);
                        }
                        100%{
                            -webkit-transform:translateY(calc( -${h}px - 100% ));
                        }
                    }`;
                }
                styleEl.innerHTML = css;
                document.head.appendChild(styleEl);
            },
        },
    };
</script>

<style lang="scss" scoped src="./jinniuyuanjing.scss"></style>
